export default __webpack_public_path__ + "static/media/team-until-20250304.77bf5439.jpeg";